export default __webpack_public_path__ + "transfix-maps/icons/D5.a8d8ab35434f3877a48910c28f73e01a.png";